<template>
	<div class="shopCarBox">
		<div class="shopItem_all_box">
			<div class="shopItem">
				<div class="shopTitleBox">
					<div class="shopTitleBox_setbox">
						<el-checkbox v-model="allChecked" @change="tabClick"></el-checkbox>
					</div>
					<div style="flex:1;">
						<tableTotal :index-show="false" :config-data="configTableTitle.configData" :loading="false"
							:headShow="true" :resizable="configTableTitle.resizable"></tableTotal>
					</div>
				</div>
				<div v-for="(item, index) in configTable.shopTableData" :key="index">
					<div class="shopItem_title flex-align-items">
						<el-checkbox v-model="item.checked" style="margin-right:25px;"
							@change="shopItemChecked(item, index)"></el-checkbox>
						<img class="w-px-18 m-r-8" src="../assets/imgs/public/store.png" alt="">
						<span class="store_box">{{ item.shopName }}</span>
					</div>
					<tableTotal :ref="'tableTotal' + index" @handleClick="handleClick"
						@selectChange="selectChangeTab(item, index)" :index-show="configTable.indexShow"
						:config-data="configTable.configData" :table-data="item.items" :loading="configTable.loading"
						:headShow="configTable.headShow">
						<template #description="{ data }">
							<div v-if="data.goodsCategory === 1">
								<div>区域范围：{{ data.goodInfo ? data.goodInfo.area || '-' : '--' }}</div>
								<div>采集时间：{{ data.goodInfo ? data.goodInfo.productDate || '-' : '--' }}</div>
								<div>产品级别：{{ data.goodInfo ? data.goodInfo.productLevel || '-' : '--' }}</div>
								<div>传感器：{{ data.goodInfo ? data.goodInfo.sensor || '-' : '--' }}</div>
								<div>规格：<span v-html="$options.filters.filter(data.goodsSpecifica)"></span></div>
							</div>
							<div v-else> - </div>
						</template>

						<template #quantity="{ data }">
							<el-input-number size="small" v-model="data.goodCount" :min="1" :step="1"
								@change="goodCountChange($event, data)"></el-input-number>
						</template>

						<template #productPrice="{ data }">
							<span class="price_num_comm">
								{{ data.goodsPriceType === 1 ? '￥' + data.goodPrice :
									(data.goodsPriceType === 2 ? '价格面议' : '免费') }}
							</span>
						</template>

						<template #subtotal="{ data }">
							<span v-if=' data.goodsPriceType ==2'> - </span>
							<span class="price_num_comm" v-else>
								￥ {{ (data.goodCount * data.goodPrice) | NumFormat }}
							</span>
						</template>

						<template #exist="{ data }">
							<span v-html="getstatus(data.goodsSpecifica.isExist)"></span>
						</template>

					</tableTotal>
				</div>
				<el-empty v-if="configTable.shopTableData.length <= 0" description="暂无数据"></el-empty>

			</div>
		</div>
		<div class="operation_box flex-be">
			<div class="operation-box-left">
				<el-checkbox v-model="allChecked" @change="tabClick">全选</el-checkbox>
				<el-button type="warning" size="small" plain @click="bulkCollect">批量收藏</el-button>
				<el-button type="primary" size="small" plain @click="batchDelFn">批量删除</el-button>
			</div>
			<div class="operation-box-right">
				<span>已选择 {{ goodsCountNum }} 个商品</span>
				<div>总价：<b>￥ {{ goodsTotalNum | NumFormat }}</b></div>
				<el-button type="primary" @click="toPay()" icon="el-icon-s-order">生成订单</el-button>
			</div>
		</div>
	</div>
</template>

<script>
import tableTotal from "@/components/TableTotal/TableTotal";

export default {
	components: {
		tableTotal,
	},
	filters: {
		filter(value) {
			if (!value) {
				return '-'
			}
			if (!value.goodsSpec) {
				return '-'
			}
			if (value.goodsSpec[0] === '{') {
				let str = value.goodsSpec.slice(1, value.goodsSpec.length - 1)
				return str.replace(/,/g, ',').replace(/"/g, '').replace(/:/g, ' : ')
			}
		}
	},
	data() {
		return {
			// 全选
			allChecked: false,
			checked: false,
			// 配置表格
			configTableTitle: {
				loading: false,
				indexShow: false,
				headShow: true,
				resizable: false,
				configData: [{
					value: "goodPic",
					label: "商品图片",
					align: "left",
					type: 'img'
				},
				{
					value: "goodName",
					label: "商品",
					align: "left",
				},
				{
					value: "value",
					label: "规格描述",
					width: 280,
					align: "left",
				},
				{
					value: "value",
					label: "单价",
					align: "left",
					type: "price"
				},
				{
					value: "value",
					label: "数量",
					width: 200,
					align: "left",
				},
				{
					value: "value",
					label: "小计",
					align: "left",
				},
				{
					value: "value",
					label: "失效",
					align: "left",
				},
				{
					label: "操作",
					width: 120,
					fixed: "right",
					type: "handleList",
					// buttonList: [
					// 	{ label: "删除", event: "seeData", show: true, showText: true, btnStyle: 'color:red;' },
					// ]
				},
				],
				tableData: [],
				current: 1, // 当前页码
				total: 10, // 数据总条数
				pageSize: 10,
			},
			// 配置表格
			configTable: {
				loading: true,
				indexShow: false,
				headShow: false,
				configData: [
					{
						type: "selection",
					},
					{
						value: "goodPic",
						label: "商品图片",
						align: "left",
						type: 'img',
					},
					{
						value: "goodName",
						label: "商品",
						align: "left",
					},
					{
						value: "value",
						label: "规格描述",
						width: 280,
						align: "left",
						type: "custom",
						customName: "description"
					},
					{
						value: "goodPrice",
						label: "单价",
						align: "center",
						type: "custom",
						customName: "productPrice"
					},
					{
						value: "orderNumber",
						label: "数量",
						width: 200,
						align: "center",
						type: "custom",
						customName: "quantity",
					},
					{
						value: "totalPrice",
						label: "小计",
						align: "center",
						type: "custom",
						customName: "subtotal"
					},
					{
						value: "value",
						label: "失效",
						align: "center",
						type: "custom",
						customName: "exist"
					},
					{
						label: "操作",
						width: 120,
						fixed: "right",
						type: "handleList",
						buttonList: [
							{
								label: "删除",
								event: "delete",
								show: true,
								showText: true,
								text: this.$PubText.carDeleteShop,
								btnStyle: 'color:red;'
							}, {
								label: "加入收藏",
								event: "collect",
								show: true,
								showText: true,
								condition: row => {
									return row.collectStatus
								}
								// text: '是否收藏该商品？',
								// btnStyle: 'color: orange;'
							},
							// {
							// 	label: "取消收藏",
							// 	event: "collectCal",
							// 	show: true,
							// 	showText: true,
							// 	condition: row => {
							// 		return !row.collectStatus
							// 	}
							// 	// text: '是否收藏该商品？',
							// 	// btnStyle: 'color: orange;'
							// }
						]
					}
				],
				shopTableData: [],
				current: 1, // 当前页码
				total: 10, // 数据总条数
				pageSize: 10,
			},
			selectGoodsArr: [],
			goodsCountNum: 0,
			goodsTotalNum: 0,
		};
	},
	computed: {},
	mounted() {
		// this.getData();
	},
	methods: {
		//是否失效
		getstatus(value) {
			if (value === 0) { //失效
				return '<span style="color: #E6A23C">已失效</span>'
			} else {
				return '<span style="color: #67C23A">正常</span>'
			}
		},

		handleSizeChange(val) {
			this.configTable.pageSize = val;
			this.getData();
		},
		async getData() {
			this.configTable.loading = true;
			try {
				let res = await this.$http.get(this.$const.common.getShoppingCart);
				console.log(res);
				if (res && res.code === 200) {
					this.configTable.loading = false;
					let data = res.data;
					data.forEach((item) => {
						item.checked = false;
						item.items.forEach(_item => {
							if (_item.goodsSpecifica && _item.goodsSpecifica.id) {
								_item.goodPrice = _item.goodsSpecifica.goodsPrice
							}
						})
					});
					this.configTable.shopTableData = data;
					console.log(this.configTable.shopTableData)
					this.allChecked = false;
				}
			} catch (error) {
				console.log(error);
			}
		},
		/*
		 * @name: 操作
		 * @time: 2022-09-29 17:57:39
		 */
		handleClick(event, data, text) {
			switch (event) {
				case 'delete':
					this.$confirm(text, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.batchDeletion(data.goodId);
					})
					break;
				case 'collect':
					this.collectProduct(data)
					break;
				case 'collectCal':
					this.collectProductCal(data)
					break;
				case 'evaluation':
					// console.log(event, data, text);
					break
			}
		},
		/*
		 * @name: 购物车中的店铺全部勾选
		 * @time: 2022-09-29 18:23:44
		 */
		shopItemChecked(data, i) {
			// console.log(data, i);
			if (this.$refs['tableTotal' + i][0].multipleSelection.length !== data.items.length) {
				this.$refs['tableTotal' + i][0].multipleSelection = data.items;
				this.$refs['tableTotal' + i][0].toggleSelection();
				this.$refs['tableTotal' + i][0].toggleSelection(data.items);
			} else {
				data.checked = false;
				this.$refs['tableTotal' + i][0].multipleSelection = [];
				this.$refs['tableTotal' + i][0].toggleSelection();
			}
			this.isTabClicked();
			// 重新计算选择了多少个商品
			this.goodsTotal();
			// 重新计算选择了多少个商品后的总价
			this.goodsTotalNumFn();
		},
		selectChangeTab(data, i) {
			let checkedCount = this.$refs['tableTotal' + i][0].multipleSelection.length;
			data.checked = checkedCount === data.items.length;
			// console.log(data.checked);
			this.isTabClicked();
			// 重新计算选择了多少个商品
			this.goodsTotal();
			// 重新计算选择了多少个商品后的总价
			this.goodsTotalNumFn();
			// console.log(checkedCount, data, ind);
		},
		tabClick() {
			this.configTable.shopTableData.length > 0 && this.configTable.shopTableData.forEach((item, i) => {
				if (this.allChecked) {
					// console.log(this.$refs['tableTotal' + i][0], item, i);
					item.checked = true;
					this.$refs['tableTotal' + i][0].multipleSelection = item.items;
					this.$refs['tableTotal' + i][0].toggleSelection();
					this.$refs['tableTotal' + i][0].toggleSelection(item.items);
				} else {
					item.checked = false;
					this.$refs['tableTotal' + i][0].multipleSelection = [];
					this.$refs['tableTotal' + i][0].toggleSelection();
				}
			});
			// 重新计算选择了多少个商品
			this.goodsTotal();
			// 重新计算选择了多少个商品后的总价
			this.goodsTotalNumFn();
		},
		isTabClicked() {
			const arr = this.configTable.shopTableData;
			for (let i = 0; i < arr.length; i++) {
				if (!arr[i].checked) {
					this.allChecked = false;
					break;
				} else {
					this.allChecked = true;
				}
			}
			// console.log(this.allChecked);
		},
		// 计算所选商品
		goodsTotal() {
			let count = 0;
			if (this.configTable && this.configTable.shopTableData.length > 0) {
				this.configTable && this.configTable.shopTableData.forEach((item, i) => {
					count += this.$refs['tableTotal' + i][0].multipleSelection.length;
				})
			}
			this.goodsCountNum = count;
		},
		// 计算总价
		goodsTotalNumFn() {
			this.selectGoodsArr = [];
			if (this.configTable && this.configTable.shopTableData.length > 0) {
				this.configTable && this.configTable.shopTableData.forEach((item, i) => {
					// console.log(item);
					// console.log(this.selectGoodsArr);
					this.selectGoodsArr = this.selectGoodsArr.concat(this.$refs['tableTotal' + i][0].multipleSelection);
				})
			}
			let total = 0;
			this.selectGoodsArr.forEach((j) => {
				total += j.totalPrice;
			});
			this.goodsTotalNum = total;
		},
		/*
		 * @name: 添加/删减 商品
		 * @time: 2022-09-30 14:44:23
		 */
		async goodCountChange(e, data) {
			// console.log(e);
			console.log(data);
			let params = {
				goodsId: data.goodId,
				number: e
			}
			if (data.goodsSpecifica.id) {
				params.goodsSpecificaId = data.goodsSpecifica.id
			}

			try {
				let res = await this.$http.put(this.$const.common.updateNumShoppingCart, params);
				if (res.code !== 200) {
					this.$message.error(res.msg);
				} else {
					await this.getData();
					this.isTabClicked();
					// 重新计算选择了多少个商品
					this.goodsTotal();
					// 重新计算选择了多少个商品后的总价
					this.goodsTotalNumFn();
				}
			} catch (error) {
				// console.log(error);
			}
		},
		bulkCollect() {
			// 批量收藏
			let collectProducts = this.selectGoodsArr.filter(item => {
				if (!item.collectStatus) return item.goodId;
			})
			if (collectProducts.length) {
				this.$http.post(this.$const.common.bulkCollectProduct, collectProducts).then(res => {
					if (res.code === 200 && res.data) {
						this.$message.success('批量收藏成功！')
					}
				}).catch(error => {
					console.log(error)
				})
			} else {
				this.$message('所选商品已在收藏中')
			}
		},
		batchDelFn() {
			// 批量删除
			if (this.goodsCountNum <= 0) {
				this.$message.warning(this.$PubText.deleteShopWarning);
				return
			}
			let arr = this.selectGoodsArr.map((item) => {
				return item.goodId
			});
			this.batchDeletion(arr.toString());
		},
		collectProduct(product) {
			// 收藏
			if (this.$store.state.user.userInfo.id) {
				this.$http.post(this.$const.RemoteSensingMall.collectadd, {
					// userId: this.$store.state.user.userInfo.id,
					collectGoodsId: product.goodId
				}).then(res => {
					if (res.code === 200 && res.data.collectTime) {
						this.$message.success('收藏成功！');
						this.getData();
					}
				}).catch(error => {
					console.log(error)
				})
			}
		},
		collectProductCal(product){
			// 取消收藏
			if (this.$store.state.user.userInfo.id) {
				this.$http.delete(this.$const.personalCenter.collectDelete, {
					// userId: this.$store.state.user.userInfo.id,
					collectId: product.goodId
				}).then(res => {
					if (res.code === 200) {
						this.$message.success('操作成功！');
						this.getData();
					}
				}).catch(error => {
					console.log(error)
				})
			}
		},
		async batchDeletion(id) {
			try {
				let res = await this.$http.delete(this.$const.common.delShoppingCart, {
					goodsId: id
				});
				if (res.code === 200) {
					// 实时更新导航购物车数据
					this.$store.dispatch("shoppingCart/getCartINFO", {});
					this.$message.success(this.$PubText.successCom);
					await this.getData();
					this.isTabClicked();
					// 重新计算选择了多少个商品
					this.goodsTotal();
					// 重新计算选择了多少个商品后的总价
					this.goodsTotalNumFn();
				} else {
					this.$message.error(res.msg);
				}
			} catch (e) {
				console.log(e);
			}
		},
		/*
		 * @name: 立即支付
		 * @time: 2022-09-30 15:45:27
		 */
		async toPay() {
			if (this.goodsCountNum <= 0) {
				this.$message.warning(this.$PubText.deleteShopWarning);
				return;
			}
			for (let item of this.selectGoodsArr) {
				if (item.goodsSpecifica && item.goodsSpecifica.goodsId) {
					if (item.goodsSpecifica.isExist === 0) { //存在失效商品
						this.$message.warning('请清除失效商品，再执行操作')
						return
					}
				}
			}
			const arr = this.selectGoodsArr.map((item) => {
				let id
				if (item.goodsSpecifica && item.goodsSpecifica.id) {
					id = item.goodsSpecifica.id
					return { goodsId: item.goodId, goodsSpecificaId: id, number: item.goodCount };
				} else {
					id = item.goodId
					return { goodsId: id, number: item.goodCount };
				}
			});
			// console.log(arr);
			let params = {
				buyType: 2,
				itemParams: arr
			};
			try {
				let res = await this.$http.post(this.$const.RemoteSensingMall.shoppingCartAddOrder, params);
				if (res && res.code === 200 && res.data) {
					// console.log(res);
					await this.$router.push({
						path: "/confirmPay",
						query: { N: res.data }
					});
				}
			} catch (e) {
				this.$message.error('服务器繁忙，请稍候再试')
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.shopTitleBox_setbox {

	border: 1px solid #e8f0ff;
	padding-left: 17px;
	height: 41px;
	line-height: 41px;
	width: 49px;
}

.shopTitleBox {
	display: flex;
	align-items: center;
}

/deep/ .shopTitleBox .is-scrolling-none {
	display: none !important;
}

.shopCarBoxPagination {
	margin: 20px 0;
	text-align: center;
}

.shopItem_all_box {
	overflow-y: auto;
	height: calc(100vh - 285px);
}

.shopItem {
	// border: 1px solid #e8f0ff;
}

.shopItem_title {
	font-size: 14px;
	height: 40px;
	line-height: 40px;
	padding: 0 18px;
	background: #eef3fe;

	.store_box {
		font-weight: bold;
		color: #474747;
	}
}

.list_title {
	display: flex;
	align-items: center;
	height: 40px;
	line-height: 40px;
	background: #fafafa;
}

.title {
	height: 40px;
	line-height: 40px;
	font-size: 1.2vw;
	margin-bottom: 20px;
}

.shopCarBox {
	background: #fff;
	padding: 20px;
	box-shadow: 0px 0px 5px #ccc;
	min-height: 60vh;
}

.operation_box {
	height: 40px;

	>.operation-box-left {

		>label {
			margin-right: 12px;
		}
	}

	>.operation-box-right {
		display: flex;
		align-items: flex-end;
		justify-content: space-between;
		width: 32%;

		>span {
			font-size: 14px;
		}

		>div {
			>b {
				font-size: 24px;
				color: #e1251b;
			}
		}

		>.el-button {
			border-radius: 0;
		}
	}
}</style>